module.exports = __webpack_public_path__ + "static/img/administrator.fa05696e.png";